import { AuditAlertSeverity } from "../auditLog.types";

export * from "./enums";

// ── URL search-param keys (Activity Log filters) ────────────────────────────
export const ADMIN_ID_FILTER_SEARCH_PARAMETER = "adminId";
export const ACTION_FILTER_SEARCH_PARAMETER = "action";
export const ENTITY_TYPE_FILTER_SEARCH_PARAMETER = "entityType";
export const ENTITY_ID_FILTER_SEARCH_PARAMETER = "entityId";
export const DATE_RANGE_FILTER_SEARCH_PARAMETER = "dateRange";

export const EMPTY_AUDIT_LOGS_FILTER_FORM_VALUES = {
  adminId: "",
  action: "",
  entityType: "",
  entityId: "",
  dateRange: null
};

// ── Severity presentation ───────────────────────────────────────────────────
export const SEVERITY_COLORS: Record<AuditAlertSeverity, string> = {
  Low: "#16C350",
  Medium: "#FF9900",
  High: "#FB3973",
  Critical: "#FF0000"
};

export const SEVERITY_ORDER: Record<AuditAlertSeverity, number> = {
  Low: 0,
  Medium: 1,
  High: 2,
  Critical: 3
};

// ── Filter seed options ─────────────────────────────────────────────────────
// `action` is matched as an ILIKE substring on the backend, so these prefixes
// catch every variant (e.g. "Earning" matches Earning.pay / Earning.cancel…).
export const AUDIT_ACTION_OPTIONS = [
  { label: "Earning.pay", value: "Earning.pay" },
  { label: "Earning.cancel", value: "Earning.cancel" },
  { label: "Earning.payMany", value: "Earning.payMany" },
  { label: "Earning.cancelMany", value: "Earning.cancelMany" },
  { label: "Earning.payAll", value: "Earning.payAll" },
  { label: "ProductVariant.update", value: "ProductVariant.update" },
  { label: "ProductVariant.imageAdd", value: "ProductVariant.imageAdd" },
  { label: "ProductVariant.imageDelete", value: "ProductVariant.imageDelete" },
  { label: "ProductVariant.imageReorder", value: "ProductVariant.imageReorder" },
  { label: "Admin.createModerator", value: "Admin.createModerator" },
  { label: "Admin.updateModerator", value: "Admin.updateModerator" },
  { label: "Admin.deleteModerator", value: "Admin.deleteModerator" },
  { label: "Admin.restore", value: "Admin.restore" },
  { label: "Reseller.block", value: "Reseller.block" },
  { label: "Reseller.unblock", value: "Reseller.unblock" }
];

export const AUDIT_ENTITY_TYPE_OPTIONS = [
  { label: "Earning", value: "Earning" },
  { label: "ProductVariant", value: "ProductVariant" },
  { label: "Admin", value: "Admin" },
  { label: "Reseller", value: "Reseller" }
];
